import { useTranslation } from 'react-i18next';

import type { DraftDuration } from '@/shared/lib/deadline-draft';

/** `2 h 30 min`, `1 d 4 h`, `3 d`: the duration in the app's compact units. */
export function useDurationText(duration: DraftDuration | null | undefined): string | null {
  const { t } = useTranslation();
  if (!duration) return null;
  if (duration.kind === 'days') return t('deadline.duration.d', { n: duration.days });
  const days = Math.floor(duration.minutes / 1440);
  const hours = Math.floor((duration.minutes % 1440) / 60);
  const minutes = duration.minutes % 60;
  return [
    days > 0 ? t('deadline.duration.d', { n: days }) : '',
    hours > 0 ? t('deadline.duration.h', { n: hours }) : '',
    minutes > 0 ? t('deadline.duration.m', { n: minutes }) : '',
  ]
    .filter(Boolean)
    .join(' ');
}
